import React, { useEffect } from "react";

import { Row, Col } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import LazyLoad from 'react-lazyload';

// CSS Files
import "../../Fonts/Fonts.css";
import "../../Statics/Common/FontStyle.css";
import "../../Statics/HomePage/OurServices.css";

// Images
import serviceOne from "../../Imgs/HomePage/OurServices/service1.svg";
import serviceTwo from "../../Imgs/HomePage/OurServices/service2.svg";
import serviceThree from "../../Imgs/HomePage/OurServices/service3.svg";
import serviceFour from "../../Imgs/HomePage/OurServices/service4.svg";
import serviceFive from "../../Imgs/HomePage/OurServices/service5.svg";
import serviceSix from "../../Imgs/HomePage/OurServices/service6.svg";
import serviceSeven from "../../Imgs/HomePage/OurServices/service7.svg";
import serviceEight from "../../Imgs/HomePage/OurServices/service8.svg";
import serviceNine from "../../Imgs/HomePage/OurServices/service9.svg";
import serviceTen from "../../Imgs/HomePage/OurServices/service10.svg";
import serviceEleven from "../../Imgs/HomePage/OurServices/service11.svg";
import serviceTwelve from "../../Imgs/HomePage/OurServices/service12.svg";

const featureText = {
  fontFamily: "IranSans",
  color: "#6d6d6d",
  fontSize: ".9em",
  marginTop: "-15px",
};
const featureTextTablet = {
  fontFamily: "IranSans",
  color: "#6d6d6d",
  fontSize: ".8em",
  marginTop: "-17.5px",
};
const featureTextMobile = {
  fontFamily: "IranSans",
  color: "#6d6d6d",
  fontSize: ".75em",
  marginTop: "-17.5px",
};

const Services = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return props.size === "laptopdesktop" ? (
    <div style={{ backgroundColor: "#ffffff" }}>
      <Center>
        <p className="subTitle">
          <strong> محصولات و نوآوری</strong>
        </p>
      </Center>
      <Center>
        <div className="subTitleHR"></div>
      </Center>
      <Margin top={3}></Margin>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <Row>
            <Col span={4}>
            <a onClick={() => props.history.push("/ourservices/6")}>
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          className="serviceLogo iconHoverEffect"
                          src={serviceSix}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={featureText}>حسابرسی</p>
                </Center>
              </a>
            </Col>
            <Col span={4}>
              <a onClick={() => props.history.push("/ourservices/5")}>
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          className="serviceLogo iconHoverEffect"
                          src={serviceFive}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={featureText}>آموزش</p>
                </Center>
              </a>
            </Col>
            <Col span={4}>
              <a onClick={() => props.history.push("/ourservices/4")}>
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          className="serviceLogo iconHoverEffect"
                          src={serviceFour}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={featureText}>ارزش گذاری</p>
                </Center>
              </a>
            </Col>
            <Col span={4}>
              <a onClick={() => props.history.push("/ourservices/3")}>
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          className="serviceLogo iconHoverEffect"
                          src={serviceThree}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={featureText}>ارزیابی ایمنی</p>
                </Center>
              </a>
            </Col>
            <Col span={4}>
              <a onClick={() => props.history.push("/ourservices/2")}>
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          className="serviceLogo iconHoverEffect"
                          src={serviceTwo}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={featureText}>ارزیابی ریسک</p>
                </Center>
              </a>
            </Col>
            <Col span={4}>
              <a onClick={() => props.history.push("/ourservices/1")}>
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          className="serviceLogo iconHoverEffect"
                          src={serviceOne}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={featureText}>ارزیابی خسارت</p>
                </Center>
              </a>
            </Col>
          </Row>
        </Col>
        <Col span={2}></Col>
      </Row>
      <Margin top={4}></Margin>
      <Row style={{ marginTop: "-10px" }}>
        <Col span={2}></Col>
        <Col span={20}>
          <Row>
            <Col span={4}>
              <a onClick={() => props.history.push("/ourservices/12")}>
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          className="serviceLogo iconHoverEffect"
                          src={serviceTwelve}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={featureText}>TPA</p>
                </Center>
              </a>
            </Col>
            <Col span={4}>
              <a onClick={() => props.history.push("/ourservices/11")}>
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          className="serviceLogo iconHoverEffect"
                          src={serviceEleven}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={featureText}>سامانه مشاوره</p>
                </Center>
              </a>
            </Col>
            <Col span={4}>
              <a onClick={() => props.history.push("/ourservices/10")}>
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          className="serviceLogo iconHoverEffect"
                          src={serviceTen}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={featureText}>تحقیق</p>
                </Center>
              </a>
            </Col>
            <Col span={4}>
              <a onClick={() => props.history.push("/ourservices/9")}>
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          className="serviceLogo iconHoverEffect"
                          src={serviceNine}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={featureText}>داوری</p>
                </Center>
              </a>
            </Col>
            <Col span={4}>
              <a onClick={() => props.history.push("/ourservices/8")}>
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          className="serviceLogo iconHoverEffect"
                          src={serviceEight}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={featureText}>آکچوئری</p>
                </Center>
              </a>
            </Col>
            <Col span={4}>
              <a onClick={() => props.history.push("/ourservices/7")}>
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          className="serviceLogo iconHoverEffect"
                          src={serviceSeven}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={featureText}>حقوقی</p>
                </Center>
              </a>
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
        <Col span={2}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div>
      <Center>
        <p className="subTitleTablet">
          <strong> محصولات و نوآوری</strong>
        </p>
      </Center>
      <Center>
        <hr className="subTitleHRTablet" />
      </Center>
      <Margin top={2}></Margin>
      <Row>
        <Col span={6}>
          <a onClick={() => props.history.push("/ourservices/4")}>
            <Center>
              <div>
                <figure>
                    <LazyLoad>
                      <img
                        className="serviceLogo iconHoverEffect"
                        src={serviceFour}
                      />
                    </LazyLoad>
                  
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextTablet}>ارزش گذاری</p>
            </Center>
          </a>
        </Col>
        <Col span={6}>
          <a onClick={() => props.history.push("/ourservices/3")}>
            <Center>
              <div>
                <figure>
                    <LazyLoad>
                    <img
                      className="serviceLogo iconHoverEffect"
                          src={serviceThree}
                    />
                      </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextTablet}>ارزیابی ایمنی</p>
            </Center>
          </a>
        </Col>
        <Col span={6}>
          <a onClick={() => props.history.push("/ourservices/2")}>
            <Center>
              <div>
                <figure>
                    <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceTwo}
                  />
                      </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextTablet}>ارزیابی ریسک</p>
            </Center>
          </a>
        </Col>
        <Col span={6}>
          <a onClick={() => props.history.push("/ourservices/1")}>
            <Center>
              <div>
                <figure>
                    <LazyLoad>
                    <img
                      className="serviceLogo iconHoverEffect"
                      src={serviceOne}
                    />
                      </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextTablet}>ارزیابی خسارت</p>
            </Center>
          </a>
        </Col>
      </Row>
      <Margin top={2}></Margin>
      <Row>
        
        <Col span={6}>
          <a onClick={() => props.history.push("/ourservices/8")}>
            <Center>
              <div>
                <figure>
                    <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceEight}
                  />
                      </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextTablet}>آکچوئری</p>
            </Center>
          </a>
        </Col>
        <Col span={6}>
        <a onClick={() => props.history.push("/ourservices/7")}>
            <Center>
              <div>
                <figure>
                    <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceSeven}
                  />
                      </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextTablet}>حقوقی</p>
            </Center>
          </a>
        </Col>
        <Col span={6}>
        <a onClick={() => props.history.push("/ourservices/6")}>
            <Center>
              <div>
                <figure>
                    <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceSix}
                  />
                      </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextTablet}>حسابرسی</p>
            </Center>
          </a>
        </Col>
        <Col span={6}>
          <a onClick={() => props.history.push("/ourservices/5")}>
            <Center>
              <div>
                <figure>
                    <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceFive}
                  />
                      </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextTablet}>آموزش</p>
            </Center>
          </a>
        </Col>
      </Row>
      <Margin top={2}></Margin>
      <Row>
        <Col span={6}>
        <a onClick={() => props.history.push("/ourservices/12")}>
            <Center>
              <div>
                <figure>
                    <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceTwelve}
                  />
                      </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextTablet}>TPA</p>
            </Center>
          </a>
        </Col>
        <Col span={6}>
          <a onClick={() => props.history.push("/ourservices/11")}>
            <Center>
              <div>
                <figure>
                    <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceEleven}
                  />
                      </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextTablet}>سامانه مشاوره</p>
            </Center>
          </a>
        </Col>
        <Col span={6}>
          <a onClick={() => props.history.push("/ourservices/10")}>
            <Center>
              <div>
                <figure>
                    <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceTen}
                  />
                      </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextTablet}>تحقیق</p>
            </Center>
          </a>
        </Col>
        <Col span={6}>
          <a onClick={() => props.history.push("/ourservices/9")}>
            <Center>
              <div>
                <figure>
                    <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceNine}
                  />
                      </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextTablet}>داوری</p>
            </Center>
          </a>
        </Col>
      </Row>
    </div>
  ) : (
    <div>
      <Center>
        <p className="subTitleMobile">
          <strong> محصولات و نوآوری</strong>
        </p>
      </Center>
      <Center>
        <div className="subTitleHRMobile"></div>
      </Center>
      <Margin top={2}></Margin>
      <Row>
        <Col span={8}>
          <a onClick={() => props.history.push("/ourservices/3")}>
            <Center>
              <div>
                <figure>
                      <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceThree}
                  />
                        </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextMobile}>ارزیابی ایمنی</p>
            </Center>
          </a>
        </Col>
        <Col span={8}>
          <a onClick={() => props.history.push("/ourservices/2")}>
            <Center>
              <div>
                <figure>
                      <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceTwo}
                  />
                        </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextMobile}>ارزیابی ریسک</p>
            </Center>
          </a>
        </Col>
        <Col span={8}>
          <a onClick={() => props.history.push("/ourservices/1")}>
            <Center>
              <div>
                <figure>
                      <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceOne}
                  />
                        </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextMobile}>ارزیابی خسارت</p>
            </Center>
          </a>
        </Col>
      </Row>
      <Margin top={2}></Margin>
      <Row>
        <Col span={8}>
          <a onClick={() => props.history.push("/ourservices/6")}>
            <Center>
              <div>
                <figure>
                      <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceSix}
                  />
                        </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextMobile}>حسابرسی</p>
            </Center>
          </a>
        </Col>
        <Col span={8}>
          <a onClick={() => props.history.push("/ourservices/5")}>
            <Center>
              <div>
                <figure>
                      <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceFive}
                  />
                        </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextMobile}>آموزش</p>
            </Center>
          </a>
        </Col>
        <Col span={8}>
          <a onClick={() => props.history.push("/ourservices/4")}>
            <Center>
              <div>
                <figure>
                      <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceFour}
                  />
                        </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextMobile}>ارزش گذاری</p>
            </Center>
          </a>
        </Col>
      </Row>
      <Margin top={2}></Margin>
      <Row>
        <Col span={8}>
          <a onClick={() => props.history.push("/ourservices/9")}>
            <Center>
              <div>
                <figure>
                      <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceNine}
                  />
                        </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextMobile}>داوری</p>
            </Center>
          </a>
        </Col>
        <Col span={8}>
          <a onClick={() => props.history.push("/ourservices/8")}>
            <Center>
              <div>
                <figure>
                      <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceEight}
                  />
                        </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextMobile}>آکچوئری</p>
            </Center>
          </a>
        </Col>
        <Col span={8}>
          <a onClick={() => props.history.push("/ourservices/7")}>
            <Center>
              <div>
                <figure>
                      <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceSeven}
                  />
                        </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextMobile}>حقوقی</p>
            </Center>
          </a>
        </Col>
      </Row>
      <Margin top={2}></Margin>
      <Row>
        <Col span={8}>
        <a onClick={() => props.history.push("/ourservices/12")}>
            <Center>
              <div>
                <figure>
                      <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceTwelve}
                  />
                        </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextMobile}>TPA</p>
            </Center>
          </a>
        </Col>
        <Col span={8}>
          <a onClick={() => props.history.push("/ourservices/11")}>
            <Center>
              <div>
                <figure>
                      <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceEleven}
                  />
                        </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextMobile}>سامانه مشاوره</p>
            </Center>
          </a>
        </Col>
        <Col span={8}>
        <a onClick={() => props.history.push("/ourservices/10")}>
            <Center>
              <div>
                <figure>
                      <LazyLoad>
                  <img
                    className="serviceLogo iconHoverEffect"
                    src={serviceTen}
                  />
                        </LazyLoad>
                </figure>
              </div>
            </Center>
            <Center>
              <p style={featureTextMobile}>تحقیق</p>
            </Center>
          </a>
        </Col>
        
      </Row>
    </div>
  );
};

export default Services;
